(function (headerView, $) {
  var colourBoundaryElements = [];
  var currentSection;
  var colourStripHeight;
  var colourChangeElements;
  var windowOffset;
  var contactAboutMenu;
  var isContactMenuHidden = false;

  headerView.init = function () {
    headerView.view = $("#top-section");
    contactAboutMenu = $(".contact-about-menu");
    colourChangeElements = $("#menu-button, #colour-strip, .menu-skew-bg, #menu, body, html");
    var colourDataElements = $("section[data-colour-boundary]");
    $.each(colourDataElements, function (index, element) {
      colourBoundaryElements.push($(element));
    });

    colourStripHeight = $("#colour-strip").height();

    wireEvents();
  };

  var currentSectionIndex = 0;
  var previousSectionOffset, nextSectionOffset;

  function wireEvents() {
    el.documentElement.on("WINDOW_SCROLL_EVENT", onScroll);
    onScroll(undefined, el.window.scrollTop());
    configureNextSections(true, false);
  }

  var previousScrollY = 0;

  function onScroll(evt, windowScrollTop) {
    windowOffset = windowScrollTop + colourStripHeight;

    if (!currentSection) {
      setCurrentSection();
    }

    if (windowOffset >= nextSectionOffset) {
      configureNextSections(false, true);
    } else if (windowOffset < previousSectionOffset) {
      configureNextSections(false, false);
    }

    if (scrollY < previousScrollY) {
      // we scrolled up
      if (scrollY < previousScrollY - 20) {
        previousScrollY = scrollY;
        if (isContactMenuHidden) {
          isContactMenuHidden = false;
          contactAboutMenu.removeClass("contact-about-menu--hidden");
        }
      }
    } else if (scrollY > previousScrollY) {
      // we scrolled down

      if (scrollY > previousScrollY + 20) {
        previousScrollY = scrollY;
        if (!isContactMenuHidden) {
          isContactMenuHidden = true;
          contactAboutMenu.addClass("contact-about-menu--hidden");
        }
      }
    }
  }

  function setCurrentSection() {
    $.each(colourBoundaryElements, function (index, element) {
      var elementOffsetTop = element.offset().top;
      if (windowOffset > elementOffsetTop && windowOffset < elementOffsetTop + element.height()) {
        currentSectionIndex = index;
        currentSection = element;
        calculateAdjacentSectionOffsets();
        return false;
      }
    });
  }

  function configureNextSections(initial) {
    if (!initial) {
      setCurrentSection();
    }

    currentSection = colourBoundaryElements[currentSectionIndex];
    calculateAdjacentSectionOffsets();
    setColour(currentSection.data("colour-boundary"));
  }

  function calculateAdjacentSectionOffsets() {
    if (currentSectionIndex === 0) {
      previousSectionOffset = -99999999;
    } else {
      previousSectionOffset =
        colourBoundaryElements[currentSectionIndex - 1].offset().top +
        colourBoundaryElements[currentSectionIndex - 1].height() -
        50;
    }

    if (currentSectionIndex + 1 < colourBoundaryElements.length) {
      nextSectionOffset = colourBoundaryElements[currentSectionIndex + 1].offset().top;
    } else {
      nextSectionOffset = 9999999;
    }
  }

  function setColour(colour) {
    colourChangeElements.stop().animate({ backgroundColor: colour }, 100);
  }
})((window.el.HeaderView = window.el.HeaderView || {}), jQuery);
